const config = {
    version: '2022.06.29',
    debug: true,
    dailyStepsForStreak: 4
};

export default config;
